module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0007.33fc7c03.jpg";